import React, { useEffect, useState, useRef } from "react";
import { Accordion, Modal, Form } from "react-bootstrap";
import { FaAngleUp } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';
import { SITE_URL } from "../../Api/config";
import { API_URL } from "../../Api/config";
import { apiCall, getCurrentUser } from "../../Api/auth";
import ButtonList from "../ButtonList/ButtonList";

function RemoateFittingAdmin({ isPopupOpen, handleLoader }) {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [userdata, setUserdata] = React.useState(null);
    const [validated, setValidated] = useState(false);

    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [descripation, setDescripation] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [heightft, setHeightft] = useState(0);
    const [heightin, setHeightin] = useState(0);
    const [dexterity, setDexterity] = useState(0);
    const [appicall, setApicall] = useState(false);
    const [serverSideError, setServerSideError] = useState(null);
    const [userid, setUserid] = useState(null);


    const [password, setPassword] = useState('');
    const [zip, setZip] = useState('');
    const [address, setAddress] = useState('');

    const [golfers, setGolfers] = useState([]);

    const phoneNumRef = useRef(null);
    const emailRef = useRef(null);

    const addGolfer = () => {
        const newGolfer = { id: Date.now(), firstName: '', lastName: '', phone_number: '', email: '' };
        setGolfers([...golfers, newGolfer]);
    };

    const removeGolfer = (id) => {
        setGolfers(golfers.filter(golfer => golfer.id !== id));
    };

    const updateGolfer = (id, field, value) => {
        const updatedGolfers = golfers.map(golfer => {
            if (golfer.id === id) {
                return { ...golfer, [field]: value };
            }
            return golfer;
        });
        setGolfers(updatedGolfers);
    };

    const handleSubmit = (event) => {
        setApicall(true);
        // handleLoader(true);
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setApicall(false);
            // handleLoader(false);
        } else {
            event.preventDefault();

            axios.post(API_URL + 'remotefittinginquires/addremotefittinginquires', {
                firstName: firstname,
                lastName: lastname,
                phoneNumber: phone,
                email: email,
                description: descripation,
                city: city,
                state: state,
                address: address,
                zip: zip,
                password: password,
                subject: 'Remoate Fitting',
                fitting_type: "remotefitting_query",
                height_in: heightin,
                height_ft: heightft,
                dexterity: dexterity,
                // userarray: { id: Date.now(), firstName: 'not set', lastName: 'not set', phone_number: '123456789', email: 'notset@test.com' }
                userarray: golfers,
                userid: userid
            }
                , {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    if (response.data.status == true) {
                        handleShow02();
                        setDescripation('');
                        setHeightft('');
                        setHeightin('');
                        setDexterity('');
                        setValidated(false);
                        setServerSideError(null);
                        handleClose();
                        setGolfers([]);
                        if (userid === null) {
                            setFirstname('');
                            setLastname('');
                            setPhone('');
                            setEmail('');
                            setCity('');
                            setState('');
                            setZip('');
                            setHeightft('');
                            setDexterity('');
                            setHeightin('');
                        }
                        if (userid !== null) {
                            localStorage.setItem("user", JSON.stringify(response.data.data));
                            setFirstname(response.data.data.firstname);
                            setLastname(response.data.data.lastname);
                            setPhone(response.data.data.phone);
                            setCity(response.data.data.city);
                            setState(response.data.data.state);
                            setZip(response.data.data.zip);
                            setHeightft(response.data.data.height_ft);
                            setHeightin(response.data.data.height_in);
                            setDexterity(response.data.data.dexterity);
                        }
                    } else {
                        setServerSideError(response.data.error);
                    }
                    // do something with response, like setting a success message state
                })
                .catch(error => {
                    console.log(error);
                    setServerSideError(error.response.data);
                    // handle the error
                }).finally(() => {
                    setApicall(false);
                    handleLoader(true);
                });
        }

        setValidated(true);
    }

    useEffect(() => {
        if (serverSideError) {
            serverSideError.data.forEach(error => {
                if (error.field === "phone_number") {
                    phoneNumRef.current.focus();
                }
                if (error.field === "email") {
                    emailRef.current.focus();
                }
            });
        }
    }, [serverSideError]);

    const [show02, setShow02] = useState(false);

    const handleClose02 = () => setShow02(false);
    const handleShow02 = () => setShow02(true);

    useEffect(() => {
        setUserdata(getCurrentUser());
        // const fetchUserData = async () => {
        //     try {
        //         const userData = await getCurrentUser();
        //         if (userData) {
        //             setUserdata(userData);
        //             setFirstname(userData.user.firstname);
        //             setLastname(userData.user.lastname);
        //             setEmail(userData.user.email);
        //             setPhone(userData.user.phone);
        //             setAddress(userData.user.address);
        //             setCity(userData.user.city);
        //             setState(userData.user.state);
        //             setZip(userData.user.zip);
        //             setUserid(userData.user._id);
        //             setHeightft(userData.user.height_ft);
        //             setHeightin(userData.user.height_in);
        //             setDexterity(userData.user.dexterity);
        //         } else {
        //             // Handle case where user data is missing or incomplete
        //             console.error('User data is missing or incomplete.');
        //         }
        //     } catch (error) {
        //         // Handle any errors that occur during data fetching
        //         console.error('Error fetching user data:', error);
        //     }
        // };

        // fetchUserData();
    }, []);


    useEffect(() => {
        if (isPopupOpen) {
            handleShow();
        }
    }, [isPopupOpen]);

    return (
        <>

            <Modal
                show={show02}
                onHide={handleClose02}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="custom-modal-header">
                        <div className="logo-modal">
                            <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                        </div>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose02} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <div className='modal-image'>
                        <img src={require('../../assets/images/forewardFormSubmitRemoteFitting.png')} alt="logo" />
                    </div>
                    <h3 className="text-center mb-4">
                        Your remote inquiry is sent!
                    </h3>
                    <p className="text-center mb-0">
                        Our staff will be in contact shortly to work out the details and get your fitting scheduled.
                    </p>
                </Modal.Body>
            </Modal>


            <Modal size="lg" centered show={show} onHide={handleClose} className="card-radius popup-modal-dark">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">Let’s Get Started</h3>
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>

                    {/* <div className="remoate-fitting-preview">
                        <img src={require('../../assets/images/thumb_img.jpg')} alt="logo" />
                    </div> */}
                    {/* <h3 className="text mb-4">Primary Golfer</h3>
                    <div className="description mb-4">
                        This should be the golfer that is ordering the remote fitting case and recieving the shipping information
                    </div> */}
                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                        <div className="row gx-2">
                            <div className="col-md-6 form-group">
                                {/* <label htmlFor="firstName">First Name</label> */}
                                <input
                                    type="text"
                                    id="firstName"
                                    name="given-name"
                                    className="form-control dashboard-input-box-3"
                                    value={firstname || ""}
                                    onChange={(e) => setFirstname(e.target.value)}
                                    placeholder="First name"
                                    autoComplete="given-name"
                                    required
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please enter a first name.
                                </Form.Control.Feedback>
                            </div>
                            <div className="col-md-6 form-group">
                                {/* <label htmlFor="lastName">Last Name</label> */}
                                <input
                                    type="text"
                                    id="lastName"
                                    name="family-name"
                                    className="form-control dashboard-input-box-3"
                                    value={lastname || ""}
                                    onChange={(e) => setLastname(e.target.value)}
                                    placeholder="Last name"
                                    autoComplete="family-name"
                                    required
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please enter a last name.
                                </Form.Control.Feedback>
                            </div>

                            <div className="col-6 col-md-3 form-group" controlid="validationCustom011">
                                <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" value={heightft} required onChange={(e) => setHeightft(e.target.value)} aria-label="Default select example">
                                    <option value={''}>ft.</option>
                                    <option value="4">4 ft.</option>
                                    <option value="5">5 ft.</option>
                                    <option value="6">6 ft.</option>
                                    <option value="7">7 ft.</option>
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a ft.
                                </Form.Control.Feedback>
                            </div>
                            <div className="col-6 col-md-3 form-group" controlid="validationCustom012">
                                <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" value={heightin} required onChange={(e) => setHeightin(e.target.value)} aria-label="Default select example">
                                    <option value={''}>in.</option>
                                    <option value="1">0 in.</option>
                                    <option value="2">1 in.</option>
                                    <option value="3">2 in.</option>
                                    <option value="4">3 in.</option>
                                    <option value="5">4 in.</option>
                                    <option value="6">5 in.</option>
                                    <option value="7">6 in.</option>
                                    <option value="8">7 in.</option>
                                    <option value="9">8 in.</option>
                                    <option value="10">9 in.</option>
                                    <option value="11">10 in.</option>
                                    <option value="12">11 in.</option>
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a in.
                                </Form.Control.Feedback>
                            </div>
                            <div className="col-12 col-md-6 form-group" controlid="validationCustom013">
                                <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" value={dexterity} onChange={(e) => setDexterity(e.target.value)} aria-label="Default select example" required>
                                    <option value={''}>Dexterity</option>
                                    <option value="1">Right Handed</option>
                                    <option value="2">Left Handed</option>
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                            <div className="col-md-12 form-group" controlid="validationCustom03">
                                <input type="tel" name="name" pattern="[0-9]{8,}" ref={phoneNumRef} value={phone || ""} title="Please enter a 8-digit phone number." onChange={(e) => setPhone(e.target.value)} className="form-control dashboard-input-box-3" placeholder="Phone" required />
                                <Form.Control.Feedback type="invalid">
                                    Please enter a 8-digit phone number.
                                </Form.Control.Feedback>
                                {serverSideError && (serverSideError.data).map((error, index) => (
                                    error.field === 'phone_number' ? (
                                        <div className="text-danger" key={index}>{error.detail}</div>
                                    ) : null
                                ))}
                            </div>
                            <div className="col-md-12 form-group" controlid="validationCustom04">
                                <input type="email" disabled={userid !== null} className="form-control dashboard-input-box-3" value={email || ""} ref={emailRef} name="email" onChange={(e) => setEmail(e.target.value)} placeholder="Email" required />
                                <Form.Control.Feedback type="invalid">
                                    Please choose a email.
                                </Form.Control.Feedback>
                                {serverSideError && (serverSideError.data).map((error, index) => (
                                    error.field === 'email' && error.userindex == 0 ? (
                                        <div className="text-danger" key={index}>{error.detail}</div>
                                    ) : null
                                ))}
                            </div>
                            <h3 className="text mt-3 mb-3">Shipping Information</h3>
                            <div className="description mb-4">
                                Let us know where exactly you want the Foreward remote fitting kit sent to.
                            </div>

                            <div className="col-md-12 form-group" controlid="validationCustom04">
                                <input type="text" className="form-control dashboard-input-box-3" value={address || ""} onChange={(e) => setAddress(e.target.value)} name="address" placeholder="Street Address, Apt. #" required />
                                <Form.Control.Feedback type="invalid">
                                    Please choose a street address.
                                </Form.Control.Feedback>
                            </div>
                            <div className="col-4 col-md-6 form-group">
                                {/* <label htmlFor="city">City</label> */}
                                <input
                                    type="text"
                                    id="city"
                                    name="address-level2"
                                    className="form-control dashboard-input-box-3"
                                    value={city || ""}
                                    onChange={(e) => setCity(e.target.value)}
                                    placeholder="City"
                                    autoComplete="address-level2"
                                    required
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please enter your city.
                                </Form.Control.Feedback>
                            </div>

                            <div className="col-4 col-md-3 form-group">
                                {/* <label htmlFor="state">State</label> */}
                                <input
                                    type="text"
                                    id="state"
                                    name="address-level1"
                                    className="form-control dashboard-input-box-3"
                                    value={state || ""}
                                    onChange={(e) => setState(e.target.value)}
                                    placeholder="State"
                                    autoComplete="address-level1"
                                    required
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please enter your state.
                                </Form.Control.Feedback>
                            </div>

                            {/* Zip Code */}
                            <div className="col-4 col-md-3 form-group">
                                {/* <label htmlFor="zip">Zip Code</label> */}
                                <input
                                    type="text"
                                    id="zip"
                                    name="postal-code"
                                    className="form-control dashboard-input-box-3"
                                    value={zip || ""}
                                    onChange={(e) => setZip(e.target.value)}
                                    placeholder="Zip Code"
                                    autoComplete="postal-code"
                                    required
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please enter your zip code.
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className='col-md-12 form-group' controlid="validationCustom05">
                            <textarea className="form-control dashboard-input-box-3 step-textarea-box" name="message" onChange={(e) => setDescripation(e.target.value)} placeholder="Any shipping notes?" rows="8"></textarea>
                            <Form.Control.Feedback type="invalid">
                                Please enter an description.
                            </Form.Control.Feedback>
                        </div>


                        <h3 className="text mt-3 mb-3">Add more golfers</h3>
                        <div className="description mb-5">
                            Add as many as you want. The only thing we require is that all players are either right or left handed.
                        </div>
                        {golfers.map((golfer, index) => (
                            <div key={golfer.id} className="add-golfer-section mb-4">
                                <div className="add-golfer-header">
                                    <div className="add-golfer-header-text">
                                        Guest {index + 1}
                                    </div>
                                    <div className="remove-golfer-section">
                                        <button type="button" className="btn-close" aria-label="Close" onClick={() => removeGolfer(golfer.id)}>
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className="add-golfer-body">
                                    <div className="row gx-2">
                                        <div className="col-6 col-md-6 form-group" controlid="validationCustom01">
                                            <input type="text" name="f-name" value={golfer.firstName}
                                                onChange={(e) => updateGolfer(golfer.id, 'firstName', e.target.value)}
                                                className="form-control dashboard-input-box-3" placeholder="First name" required />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a first name.
                                            </Form.Control.Feedback>
                                        </div>
                                        <div className="col-6 col-md-6 form-group" controlid="validationCustom01">
                                            <input type="text" name="l-name" value={golfer.lastName}
                                                onChange={(e) => updateGolfer(golfer.id, 'lastName', e.target.value)} className="form-control dashboard-input-box-3" placeholder="Last name" required />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a first name.
                                            </Form.Control.Feedback>
                                        </div>
                                        <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" value={golfer.ft} onChange={(e) => updateGolfer(golfer.id, 'heightft', e.target.value)} aria-label="Default select example" required>
                                                <option value={''}>ft.</option>
                                                <option value="4">4 ft.</option>
                                                <option value="5">5 ft.</option>
                                                <option value="6">6 ft.</option>
                                                <option value="7">7 ft.</option>
                                            </select>
                                            <Form.Control.Feedback type="invalid">
                                                Please select a ft.
                                            </Form.Control.Feedback>
                                        </div>
                                        <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" onChange={(e) => updateGolfer(golfer.id, 'heightin', e.target.value)} aria-label="Default select example" required>
                                                <option value={''}>in.</option>
                                                <option value="1">0 in.</option>
                                                <option value="2">1 in.</option>
                                                <option value="3">2 in.</option>
                                                <option value="4">3 in.</option>
                                                <option value="5">4 in.</option>
                                                <option value="6">5 in.</option>
                                                <option value="7">6 in.</option>
                                                <option value="8">7 in.</option>
                                                <option value="9">8 in.</option>
                                                <option value="10">9 in.</option>
                                                <option value="11">10 in.</option>
                                                <option value="12">11 in.</option>
                                            </select>
                                            <Form.Control.Feedback type="invalid">
                                                Please select a in.
                                            </Form.Control.Feedback>
                                        </div>
                                        <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" onChange={(e) => updateGolfer(golfer.id, 'dexterity', e.target.value)} aria-label="Default select example" required>
                                                <option value={''}>Dexterity</option>
                                                <option value="1">Right Handed</option>
                                                <option value="2">Left Handed</option>
                                            </select>
                                            <Form.Control.Feedback type="invalid">
                                                Please select a Dexterity
                                            </Form.Control.Feedback>
                                        </div>
                                        <div className="col-md-12 form-group" controlid="validationCustom03">
                                            <input type="tel" name="phone_number" pattern="[0-9]{8,}" value={golfer.phone_number}
                                                onChange={(e) => updateGolfer(golfer.id, 'phone_number', e.target.value)} title="Please enter a 8-digit phone number." className="form-control dashboard-input-box-3" placeholder="Phone" required />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a 8-digit phone number.
                                            </Form.Control.Feedback>
                                        </div>
                                        <div className="col-md-12 form-group" controlid="validationCustom04">
                                            <input type="email" className="form-control dashboard-input-box-3" value={golfer.email}
                                                onChange={(e) => updateGolfer(golfer.id, 'email', e.target.value)} name="email" placeholder="Email" required />
                                            <Form.Control.Feedback type="invalid">
                                                Please choose a email.
                                            </Form.Control.Feedback>
                                            {serverSideError && (serverSideError.data).map((error, errorindex) => (
                                                error.field == 'email' && error.userindex == index + 1 ? (
                                                    <div className="text-danger" key={errorindex}>{error.detail}</div>
                                                ) : <></>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div className="col-md-12 text-center">
                            <div className='full-width-btn'>
                                <button className="btn btn_default bg-white text-dark btn_disabled" onClick={addGolfer} type="button">
                                    <span>+ Add Golfer</span>
                                </button>
                            </div>
                        </div>
                        <h3 className="text mt-4 mb-3">Get Your Remote Fitting Started</h3>
                        <div className="description mb-5">
                            Once you fill out this form our team will be in touch within 24 hours to coordinate your remote club fitting.
                        </div>
                        <div className="col-md-12 text-center">
                            <div className='full-width-btn'>
                                <button className="btn btn_default bg-white text-dark btn_disabled" type="submit">
                                    {
                                        appicall ? <Spinner animation="border" className="border-black" /> : <span>Start Your Fitting </span>
                                    }
                                </button>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal >
        </>
    );
}

export default RemoateFittingAdmin;